import Reveal from "@/components/base/Reveal";
import { stats } from "@/mocks/home";

const highlights = [
  {
    icon: "ri-road-map-line",
    title: "全国农场点位",
    desc: "多点农场规模化、标准化、网格化布局，分散规避天灾风险",
  },
  {
    icon: "ri-cpu-line",
    title: "九宫八卦布局",
    desc: "以易经九宫八卦为纲，打造东方田园仙境的景观体系",
  },
  {
    icon: "ri-goblet-line",
    title: "原生建造美学",
    desc: "竹木石沙原生建造体系，还原自然本真的栖居美学",
  },
  {
    icon: "ri-hand-heart-line",
    title: "社会帮扶共建",
    desc: "大学生创业、宝妈、残障人士、孤寡老人共建田园大家庭",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-secondary-600 text-sm font-medium">
              <i className="ri-flag-2-line"></i>
              三明农链工程专题
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
              重构社会生态，共建田园共同体
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mt-5">
              以农耕为载体，重建邻里、家庭、企业、兴趣圈层之间的链接，实现老有所养、幼有所育。让土地不再是土地，而是梦想、人脉、情感与永续财富的载体。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-7">
              {highlights.map((item) => (
                <div key={item.title} className="flex gap-3">
                  <span className="w-10 h-10 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950">{item.title}</h4>
                    <p className="text-xs text-foreground-600 leading-relaxed mt-1">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative rounded-lg overflow-hidden bg-primary-900 p-8 md:p-10 text-white">
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-accent-500/20 blur-2xl"></div>
              <div className="relative">
                <p className="text-sm text-white/70">工程代号 · 三明农链工程</p>
                <p className="font-heading text-lg md:text-xl font-semibold mt-2">
                  让每一块土地都承载温度与希望
                </p>
                <div className="grid grid-cols-2 gap-4 mt-8">
                  {stats.map((stat) => (
                    <div key={stat.label} className="rounded-lg bg-white/10 p-5 text-center">
                      <p className="font-heading text-3xl md:text-4xl font-bold text-accent-400">
                        {stat.value}
                      </p>
                      <p className="text-xs text-white/70 mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}